import { gql } from "@apollo/client";

export const MANAGED_RECEIVED_FAXES_SUBSCRIPTION = gql`
    subscription ManagedReceivedFaxesSubscription {
      inbound_faxes:received_faxes(order_by: {created_at: desc}, where: {status: {_neq: "deleted"}}) {
        id
        external_id
        source
        metadata
        status
        created_at
        clinic {
          id
          name
        }
      }
    }
`;


export const RECEIVED_FAXES_SUBSCRIPTION = gql`
    subscription ReceivedFaxesSubscription($clinicId: bigint!) {
      inbound_faxes:received_faxes(order_by: {created_at: desc}, where: {status: {_neq: "deleted"}, clinic_id: {_eq: $clinicId}}) {
        id
        external_id
        source
        metadata
        status
        created_at
        clinic {
          id
          name
        }
      }
    }
`;

// export const GET_RECEIVED_FAXES = gql`
//   query GetReceivedFaxes {
//     inbound_faxes {
//       id
//       external_id
//       source
//       metadata {
//         uri
//         subject
//         from_number
//         from_location
//         pages_count
//         date_created
//       }
//       status
//       clinic {
//         id
//         name
//       }
//     }
//   }
// `;

export const GET_RECEIVED_FAX_DETAILS = gql`
  query GetReceivedFaxDetails($id: ID!) {
    inbound_fax_details(id: $id) {
        id 
        external_id
        pdf_b64
        actions {
            can_select_receiving_provider
        }
        metadata
        ocr_data
        processed_data {
            received_fax_id
            detected_referrals {
                pdf_pages
                patient_name
                firstname
                lastname
                birthdate {
                    value
                    avg_confidence
                    pages
                }
                ssn {
                    value
                    avg_confidence
                    pages
                }
                diagnosis {
                    value
                    avg_confidence
                    pages
                }
                referring_clinic {
                    value
                    avg_confidence
                    pages
                }
                form_suggestion {
                    firstname
                    lastname
                    birthdate
                    ssn
                    diagnosis
                    referring_clinic
                    receiving_provider
                }
            }
        }
    }
  }
`;

export const SAVE_FAX_REFERRAL = gql`
  mutation SaveFaxReferral($received_fax_id: ID!, $firstname: String!, $lastname: String!, $start_page: Int!, $end_page: Int!, $ssn: String!, $birthdate: String, $diagnosis: String, $referring_clinic: ID, $receiving_provider: Int) {
    save_fax_referral(received_fax_id: $received_fax_id, firstname: $firstname, lastname: $lastname, start_page: $start_page, end_page: $end_page, ssn: $ssn, birthdate: $birthdate, diagnosis: $diagnosis, referring_clinic: $referring_clinic, provider_id: $receiving_provider) {
      id
      provider {
        documents {
          document {
            id
          }
        }
      }
    }
  }
`;

export const DELETE_RECEIVED_FAX = gql`
  mutation DeleteReceivedFax($faxId: ID!) {
    delete_received_fax(fax_id: $faxId)
  }
`;
